import { render, staticRenderFns } from "./DropZone.vue?vue&type=template&id=2e4d477a&scoped=true"
import script from "./DropZone.ts?vue&type=script&lang=ts&external"
export * from "./DropZone.ts?vue&type=script&lang=ts&external"
import style0 from "./DropZone.scss?vue&type=style&index=0&id=2e4d477a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4d477a",
  null
  
)

export default component.exports